import Logo from "../../Logo";
import NavLink from "../NavLink";
import ExitButton from "../../ExitButton";
import { FunctionComponent } from "react";

import styles from "./styles.module.css";

interface NavProps {
  activeIndex: number;
}

const Navbar: FunctionComponent<NavProps> = ({ activeIndex }) => {
  return (
    <nav className={styles.navBar}>
      <Logo />
      <ul>
        <NavLink
          name="Conta"
          link="/conta"
          icon="group"
          active={activeIndex === 0}
        />
        <NavLink
          name="Termos"
          link="/planos-de-trabalho"
          icon="document"
          active={activeIndex === 1}
        />
        <NavLink
          name="Editais"
          link="/editais"
          icon="hands"
          active={activeIndex === 2}
        />
      </ul>
      <ExitButton />
    </nav>
  );
};

export default Navbar;
